import BarChartIcon from '@mui/icons-material/BarChart';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

export const menus = [
    {
        title: 'Resultados',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardvitalstatistics/results',
        gap: true
    },
    {
        title: 'Nascidos Vivos',
        icon: <ChildCareIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardvitalstatistics/live-births',
    },
    {
        title: 'Mortalidade',
        icon: <SentimentVeryDissatisfiedIcon className="menu-icon-sidebar-dashboards" fontSize='large' />,
        path: '/governanceroom/dashboardvitalstatistics/mortality',
    },
];